<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class=""
      >Cadastro Mensagem: <br> Use &#123;nome_paciente&#125; para se referir ao nome do paciente <br>
      Use &#123;valor&#125; para se referir ao valor da medição <br>
      Use &#123;classificacao&#125; para se referir à classificação daquela medição</mat-card-title
    >
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div [formGroup]="form" class="mt-8 mb-0">
    <div>
      <div class="flex justify-between gap-4 items-center">
        <mat-form-field class="input-tg w-6/12" appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field class="input-tg w-6/12" appearance="outline">
          <mat-label>Tipo de Uso</mat-label>
          <mat-select formControlName="useType">
            @for (item of listUseTypes; track item.value) {
              <mat-option [value]="item.id">{{ item.nome + ' - ' + item.descricao}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="input-tg w-full" appearance="outline">
          <mat-label>Texto</mat-label>
          <textarea matInput placeholder="Olá {nome_paciente}, sua medição é {valor} mg/dL. Considerada uma classificação {classificacao}, recomendamos que beba pelo menos 2L de água." formControlName="text"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="flex justify-end mt-3">
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="!this.form.valid || loading"
        (click)="createLocation()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Cadastrar
        }
      </button>
    </div>
  </div>
</mat-card>
